module.exports = __webpack_public_path__ + "static/img/time-out.54273b79.png";